import React from 'react';
import { Link } from 'react-router-dom';
import { ServicePageLayout } from '../components/ServicePageLayout';
import { PackagePricing } from '../components/PackagePricing';
import { FeatureItem } from '../components/FeatureItem';
import { RelatedLinks } from '../components/RelatedLinks';
import { packages } from '../data/packages';
const pkg = packages.find(p => p.slug === 'basic-wash')!;
const faqs = [{
  question: 'How much does a Basic Wash cost?',
  answer: 'A Basic Wash is $90 for small and mid-size vehicles and $105 for SUVs and crossovers. A limited-time $10 off is currently available (2 car minimum on Basic Wash only).'
}, {
  question: 'Is there a minimum for the Basic Wash?',
  answer: 'Yes. Basic Washes require a minimum of 2 cars per appointment.'
}, {
  question: 'What is included in a Basic Wash?',
  answer: 'An exterior wash, light wipe-down, vacuum, clean rims, tire dressing, and window cleaning.'
}, {
  question: 'How is the Basic Wash different from the Wash & Wax?',
  answer: 'The Wash & Wax adds a hybrid ceramic spray, which leaves a protective layer that helps paint stay shiny and repel water and dirt.'
}];
export function BasicWashPage() {
  return <ServicePageLayout title="Basic Wash" subtitle="A maintenance wash that covers the essentials — exterior wash, light wipe-down, vacuum, rims, tires, and windows. 2 car minimum." metaDescription="Mobile Basic Wash in Ventura County — exterior wash, wipe-down, vacuum, rims, tires and windows. $90 SM/Mid, $105 SUV, 2 car minimum. Call or text 818-381-9905." schema={{
    '@type': 'Service',
    name: 'Basic Wash',
    serviceType: 'Mobile Car Wash',
    provider: {
      '@type': 'LocalBusiness',
      name: "Mike's Pro Detail"
    },
    areaServed: ['Ventura County', 'Camarillo', 'Ventura', 'Thousand Oaks'],
    description: `${pkg.summary} Two car minimum.`,
    offers: [{
      '@type': 'Offer',
      price: '90',
      priceCurrency: 'USD',
      description: 'Small / mid-size vehicle, 2 car minimum'
    }, {
      '@type': 'Offer',
      price: '105',
      priceCurrency: 'USD',
      description: 'SUV / crossover, 2 car minimum'
    }]
  }} faqs={faqs} breadcrumbs={[{
    name: 'Home',
    item: 'https://www.fulldetailpro.com/'
  }, {
    name: 'Services',
    item: 'https://www.fulldetailpro.com/services'
  }, {
    name: 'Basic Wash',
    item: 'https://www.fulldetailpro.com/basic-wash'
  }]} data-id="element-602" data-mp="o0l53jno7use">
      <p data-id="element-603" data-mp="1vcqzqqwxg2yp">
        The <strong data-id="element-604" data-mp="1vd8u1i01473z">Basic Wash</strong> keeps a regularly cared-for car looking
        sharp. It's ideal for households with more than one vehicle — Basic
        Washes are booked with a <strong data-id="element-605" data-mp="1ll36ckgt8bul">2 car minimum</strong> — and we
        perform it at your home or office anywhere in Ventura County.
      </p>

      <PackagePricing pkg={pkg} data-id="element-606" data-mp="1gocqny8x3i9p" />

      <figure className="not-prose my-10" data-id="element-607" data-mp="1bnoz9bgs0zey">
        <img src="https://cdn.magicpatterns.com/uploads/tHx2awfeErZsyTBv2bEsWN/Before_and_After_Gallery_Site.jpg" alt="Before and after exterior wash on a Honda SUV" loading="lazy" decoding="async" className="w-full h-auto rounded-xl border border-zinc-800" data-id="element-608" data-mp="1bmnc48mhkmgv" />
      </figure>

      <h2 data-id="element-609" data-mp="3naipyu4mvcyf">Benefits of a Basic Wash</h2>
      <ul className="space-y-4 my-6 list-none pl-0" data-id="element-610" data-mp="3n9h1nnylwtyr">
        <FeatureItem data-id="element-611" data-mp="3sael03vcru1u">
          <strong data-id="element-612" data-mp="3sb6g7dl1fprl">The essentials, covered:</strong> exterior wash, windows,
          rims, and tire dressing.
        </FeatureItem>
        <FeatureItem data-id="element-613" data-mp="132ced8jcoxj">
          <strong data-id="element-614" data-mp="11hhgmib73z5">A tidier cabin:</strong> vacuum and a light wipe-down.
        </FeatureItem>
        <FeatureItem data-id="element-615" data-mp="2zjmqdatxrdgm">
          <strong data-id="element-616" data-mp="34kar4o7yv8o1">No drop-off:</strong> we bring our own water and detailing
          equipment. We require access to a standard electrical outlet at the
          service location.
        </FeatureItem>
      </ul>

      <h2 data-id="element-617" data-mp="3eana4c04uts2">Need Paint Protection?</h2>
      <p data-id="element-618" data-mp="3ebygmjkyqfmv">
        Upgrade to the <Link to="/wash-wax" data-id="element-619" data-mp="3ec6t4ad6bixj">Wash & Wax</Link> for a hybrid
        ceramic spray, or book the <Link to="/full-detail" data-id="element-620" data-mp="2gsvmgospwf9m">Full Detail</Link>{' '}
        for a complete interior and exterior restoration.
      </p>

      <h2 data-id="element-621" data-mp="rdue9jdfwjad">Related Services</h2>
      <RelatedLinks links={[['/wash-wax', 'Wash & Wax'], ['/full-detail', 'Full Detail'], ['/services', 'All Services & Pricing'], ['/specials', 'Current Specials']]} data-id="element-622" data-mp="rd2oip6ixfs0" />
    </ServicePageLayout>;
}